import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Button } from "@/components/ui/button";
import { QrCode, X } from "@phosphor-icons/react";

export default function QRScanner({ onScan }) {
    const scannerRef = useRef(null);
    const containerId = "qr-scanner-region";
    const [active, setActive] = useState(false);
    const [error, setError] = useState(null);

    const start = async () => {
        setError(null);
        try {
            const scanner = new Html5Qrcode(containerId);
            scannerRef.current = scanner;
            await scanner.start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 220, height: 220 } },
                (decoded) => {
                    onScan?.(decoded);
                    stop();
                },
                () => {},
            );
            setActive(true);
        } catch (e) {
            setError("Camera unavailable for scanning");
        }
    };

    const stop = async () => {
        try {
            if (scannerRef.current) {
                await scannerRef.current.stop();
                await scannerRef.current.clear();
            }
        } catch {}
        scannerRef.current = null;
        setActive(false);
    };

    useEffect(() => () => { stop(); }, []);

    return (
        <div>
            <div
                id={containerId}
                className={`w-full ${active ? "aspect-square" : "h-0"} bg-zinc-900 rounded-md overflow-hidden border border-border`}
            />
            {!active && (
                <div className="w-full aspect-square flex flex-col items-center justify-center gap-2 bg-zinc-100 dark:bg-zinc-900 rounded-md border border-border text-muted-foreground p-6">
                    <QrCode size={44} weight="duotone" />
                    <span className="text-sm">Scan visitor QR / pass</span>
                    {error && <span className="text-xs text-red-500">{error}</span>}
                </div>
            )}
            <div className="mt-3">
                {!active ? (
                    <Button
                        type="button"
                        onClick={start}
                        data-testid="btn-qr-start"
                        className="w-full h-11 bg-brand hover:bg-brand/90 text-white"
                    >
                        <QrCode className="mr-2" size={18} /> Start QR Scan
                    </Button>
                ) : (
                    <Button
                        type="button"
                        onClick={stop}
                        variant="outline"
                        data-testid="btn-qr-stop"
                        className="w-full h-11"
                    >
                        <X className="mr-2" size={18} /> Stop
                    </Button>
                )}
            </div>
        </div>
    );
}
